import clsx from 'clsx'

// A row of joined buttons where one may be current: a segmented control. Adapted from the Tailwind
// Plus reference design/components/elements/button-groups/01-basic.jsx (kept out of catalyst/).

export function ButtonGroup({ className, ...props }: React.ComponentPropsWithoutRef<'span'>) {
  return <span role="group" {...props} className={clsx(className, 'isolate inline-flex rounded-md shadow-xs dark:shadow-none')} />
}

const tone = {
  zinc: 'bg-zinc-900 text-white inset-ring-zinc-900 dark:bg-white dark:text-zinc-900 dark:inset-ring-white',
  emerald: 'bg-emerald-600 text-white inset-ring-emerald-600 dark:bg-emerald-500 dark:inset-ring-emerald-500',
  red: 'bg-red-600 text-white inset-ring-red-600 dark:bg-red-500 dark:inset-ring-red-500',
}

export function ButtonGroupItem({
  current = false,
  currentTone = 'zinc',
  className,
  ...props
}: { current?: boolean; currentTone?: keyof typeof tone } & React.ComponentPropsWithoutRef<'button'>) {
  return (
    <button
      type="button"
      aria-pressed={current}
      {...props}
      className={clsx(
        className,
        'relative -ml-px inline-flex items-center px-2.5 py-1 text-xs font-semibold inset-ring-1 first:ml-0 first:rounded-l-md last:rounded-r-md focus:z-10',
        current
          ? tone[currentTone]
          : 'bg-white text-zinc-900 inset-ring-zinc-300 hover:bg-zinc-50 dark:bg-white/10 dark:text-white dark:inset-ring-zinc-700 dark:hover:bg-white/20',
      )}
    />
  )
}
